import CalendarPicker from './CalendarPicker'
import withRefButton from './withRefButton'

export default withRefButton(CalendarPicker)
